var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.305 0H2.695C1.98024 0 1.29476 0.283937 0.789348 0.789348C0.283937 1.29476 0 1.98024 0 2.695V46.305C0 47.0198 0.283937 47.7052 0.789348 48.2107C1.29476 48.7161 1.98024 49 2.695 49H26.166V30.0125H19.796V22.6625H26.166V17.15C26.034 15.8558 26.1868 14.5484 26.6137 13.3195C27.0405 12.0906 27.731 10.97 28.6367 10.0362C29.5425 9.10243 30.6416 8.37812 31.8569 7.91408C33.0723 7.45005 34.3744 7.25752 35.672 7.35C37.5789 7.33827 39.4849 7.43643 41.3805 7.644V14.259H37.485C34.398 14.259 33.81 15.729 33.81 17.8605V22.589H41.16L40.2045 29.939H33.81V49H46.305C46.6589 49 47.0094 48.9303 47.3363 48.7949C47.6633 48.6594 47.9604 48.4609 48.2107 48.2107C48.4609 47.9604 48.6594 47.6633 48.7949 47.3363C48.9303 47.0094 49 46.6589 49 46.305V2.695C49 2.34109 48.9303 1.99064 48.7949 1.66367C48.6594 1.3367 48.4609 1.0396 48.2107 0.789348C47.9604 0.539094 47.6633 0.340581 47.3363 0.205145C47.0094 0.0697085 46.6589 0 46.305 0Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a726c2a9bfddc63e89f1880a53024da0.svg";
export { ForwardRef as ReactComponent };